// angular
import { Routes } from '@angular/router';
// components
import { LayoutComponent } from '@app/layout/layout.component';
import { NotFoundComponent } from './not-found/not-found.component';
import { HomeComponent } from './+home/home.component';
import { QuickOrderFormComponent } from '@quick-order/quick-order-form/quick-order-form.component';

export const routes: Routes = [
  {
    path: '',
    component: LayoutComponent,
    children: [
      {
        path: '',
        loadComponent: () =>
          import('@home/home.component').then(m => m.HomeComponent),
        data: { titleKey: 'wejoiner', hiddenTopSearchBar: true },
      },
      {
        path: 'auctions',
        loadChildren: () =>
          import('@auctions/auctions.routes').then(m => m.AuctionsRoutes),
      },
      {
        path: 'tenders',
        loadChildren: () =>
          import('@tenders/tenders.routes').then(m => m.TendersRoutes),
      },
      {
        path: 'products',
        loadChildren: () =>
          import('@products/products.routes').then(m => m.ProductsRoutes),
      },
      {
        path: 'categories',
        loadChildren: () =>
          import('@categories/categories.routes').then(m => m.CategoriesRoutes),
      },
      {
        path: 'services',
        loadChildren: () =>
          import('@services/services.routes').then(m => m.ServicesRoutes),
      },
      {
        path: 'industries',
        loadChildren: () =>
          import('@suppliers/suppliers.routes').then(m => m.SuppliersRoutes),
      },

      // temporary : this route commented temporary
      // {
      //   path: 'blogs',
      //   loadChildren: () =>
      //     import('@blogs/blogs.routes').then(m => m.BlogsRoutes),
      // },

      {
        path: 'help',
        loadChildren: () => import('@help/help.routes').then(m => m.HelpRoutes),
      },

      {
        path: 'about',
        loadChildren: () =>
          import('@about/about.routes').then(m => m.AboutRoutes),
      },
      {
        path: 'profile',
        loadChildren: () =>
          import('@profile/profile.routes').then(m => m.ProfileRoutes),
        data: { hiddenTopSearchBar: true },
      },
      {
        path: 'quick-orders',
        loadChildren: () =>
          import('@quick-order/quick-order.routes').then(
            m => m.QuickOrderRoutes
          ),
      },
      {
        path: 'qo',
        component: QuickOrderFormComponent,
        data: { titleKey: 'routes.quickOrders' },
      },
      {
        path: 'search-results',
        loadChildren: () =>
          import('@app/+search/search-results.routes').then(
            m => m.SearchRoutes
          ),
      },
      // temporary : this route commented temporary
      // {
      //   path: 'explore',
      //   loadChildren: () =>
      //     import('@explores/explores.routes').then((m) => m.ExploresRoutes),
      // },
    ],
  },
  {
    path: '404',
    component: NotFoundComponent,
    data: { titleKey: 'routes.notFound' },
  },
  {
    path: '',
    loadChildren: () =>
      import('@portfolio/portfolio.routes').then(m => m.PortfolioRoutes),
  },
  {
    path: 'p',
    loadChildren: () =>
      import('@portfolio/portfolio.routes').then(m => m.PortfolioRoutes),
  },
  {
    path: '**',
    component: NotFoundComponent,
    data: { titleKey: 'routes.notFound' },
  },
];
